import http from "@/shared/services/http";
import {LadingCareParams} from "@/modules/ladingcare/params";

export const createLadingCare = (form: any) => {
    return http.post("/v1/ladings-care", form);
}

export const listLadingCare = (params: LadingCareParams) => {
    return http.get("/v1/ladings-care", {params});
}

export const singleLadingCare = (id: number) => {
    return http.get(`/v1/ladings-care/${id}`);
}

export const updateLadingCare = (id: number, form: any) => {
    return http.put(`/v1/ladings-care/${id}`, form);
}

export const allLadingCare = (params?: LadingCareParams) => http.get("/v1/ladings-care/all", {params});
